const reducer = (state, action) => {
    switch (action.type) {
        case 'retrieved':
            return {
                ...state,
                ...action.payload,
                hasMore: action.payload?.associations?.[0]?.TotalRecordCount > action.payload?.associations?.length,
                isFetching: false,
                recOffset:
                    action.payload?.associations?.[0]?.TotalRecordCount > action.payload?.associations?.length
                        ? state.recOffset + 10
                        : state.recOffset,
            };
        case 'sort':
            return {
                ...state,
                ...action.newState,
                associations: [],
                hasMore: true,
                recOffset: 0,
                isFetching: true,
            };
        case 'sorted':
            return {
                ...state,
                associations: action.list,
                hasMore: action?.list?.[0]?.TotalRecordCount > action?.list?.length,
                recOffset: 0,
                isFetching: false,
            };
        case 'append':
            const arr = [...state.associations, ...action.list];
            return {
                ...state,
                associations: arr,
                hasMore: arr?.[0]?.TotalRecordCount > arr?.length,
                recOffset: arr?.[0]?.TotalRecordCount > arr?.length ? state.recOffset + 25 : state.recOffset,
                isFetching: false,
            };
        case 'fetching':
            return {
                ...state,
                isFetching: true,
            };
        case 'errored':
            return {
                ...state,
                isFetching: false,
            };
        case 'dismiss':
            return { UserID: state.UserID };
        default:
            console.log('Invalid action type');
            return state;
    }
};

export default reducer;
